(() => {
  function initialize() {
    if (window.Shopify?.designMode) return;
    document.querySelectorAll('[data-interior-masthead]').forEach((section) => {
      if (section.dataset.interiorInitialized || section.closest('[hidden]')) return;
      section.dataset.interiorInitialized = 'true';
      const image = section.querySelector('.interior-masthead__image');
      const data = section.querySelector('[data-interior-family]');
      if (!image || !data || section.dataset.rotation === 'false') return;
      try {
        const family = JSON.parse(data.textContent);
        if (!Array.isArray(family) || family.length < 2 || family.some(item => typeof item.src !== 'string' || !item.src)) return;
        const key = 'sobo-interior-elemental-v1';
        const stored = Number.parseInt(window.sessionStorage.getItem(key), 10);
        const index = Number.isInteger(stored) && stored >= 0 && stored < family.length ? stored : 0;
        const advance = () => { try { window.sessionStorage.setItem(key, String((index + 1) % family.length)); } catch { /* Artwork is optional. */ } };
        if (index === 0) { advance(); return; }
        const selected = family[index];
        const preload = new Image();
        preload.onload = () => {
          image.removeAttribute('srcset');
          image.src = selected.src;
          advance();
        };
        preload.src = selected.src;
      } catch {
        // The server-rendered botanical image and full text remain usable.
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
